export class GridConfiguration {
  gridName: string;
}
